import { useState } from 'react'
import { Trans } from 'react-i18next'

import { DefaultVariableResult, VariableResultCurrentRow } from '@makyoapp/makyo-common'
import { ArrowShortRight16, Db16, Table16 } from '@makyoapp/makyo-icon/icon'
import { Chip, ChipProps } from '@makyoapp/makyo-ui'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ColumnTypeIcon } from '@/components/ColumnTypeIcon'

import { VariableCurrentRowBody } from '../VariableCurrentRow'
import { useVariableSelectContext } from '../VariableSelectContext'
import { DragHandler, EditDD } from './components'

export default function ChipCurrentRow({
  value,
  index,
  chipProps: { listeners, ...chipProps },
}: {
  value: VariableResultCurrentRow
  index: number
  chipProps: ChipProps & any
}) {
  const { value: contextValue, onChange, multiple, variableColumnOptions } = useVariableSelectContext()
  const { tables, db } = useDbClientContext()

  const { activeLayerTableId } = useActiveLayerContext()

  const [show, setShow] = useState(false)
  const [us, setUs] = useState(value.userSpecific)

  const dbObj = db
  const tblObj = tables.find(({ id }) => id === activeLayerTableId)
  const colObj = tblObj?.columns.find((c) => c.id === value?.col)

  return (
    <Chip
      {...chipProps}
      tipClassName='text-m-sm'
      portalTip
      title={
        <div className='flex-c'>
          <div className='text-center whitespace-nowrap'>
            <Trans>Current Row</Trans>
          </div>
          <div className='flex-c'>
            <div className='flex-c'>
              <Db16 />
              {dbObj?.name}
            </div>
            {tblObj && (
              <>
                <ArrowShortRight16 />
                <div className='flex-c whitespace-nowrap'>
                  <Table16 />
                  {tblObj.name}
                </div>
              </>
            )}
            {colObj && (
              <>
                <ArrowShortRight16 />
                <div className='flex-c whitespace-nowrap'>
                  <ColumnTypeIcon type={colObj.type} />
                  {colObj.name}
                </div>
              </>
            )}
          </div>
        </div>
      }
    >
      <DragHandler listeners={listeners} />

      <div className='flex-c txt w-full'>{colObj?.name || <Trans>Current Row</Trans>}</div>

      <EditDD
        show={show}
        onToggle={(nextShow) => {
          if (!nextShow) {
            if (value.userSpecific !== us) {
              setUs(value.userSpecific)
            }
          }
          setShow(nextShow)
        }}
        menuWrapperClassName='py-2'
      >
        <VariableCurrentRowBody
          setShow={() => {}}
          columnTypes={variableColumnOptions.columnTypes}
          value={
            multiple
              ? ((contextValue as [])[index] as VariableResultCurrentRow)
              : (contextValue as VariableResultCurrentRow)
          }
          onChange={(next) => {
            const nextVal = multiple
              ? ([...((contextValue as DefaultVariableResult[]) ?? [])] as DefaultVariableResult[])
              : next

            if (multiple) {
              ;(nextVal as DefaultVariableResult[])[index] = next
            }
            onChange(nextVal)
          }}
          setUserSpecific={setUs}
          userSpecific={us}
        />
      </EditDD>
    </Chip>
  )
}
